import cardTemplateUrl from 'emun.vendor/vendor-contacts.htm'
import tableTemplateUrl from 'emun.vendor/vendor-contacts-table.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import ServiceBus from 'servicestack/service-bus'
import VendorContactPopup from 'emun.vendor/vendor-contact.popover'

class VendorContactsController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$on('contactSaved', () => $ctrl.contacts.load(true));
    $ctrl.$on('contactDeleted', () => $ctrl.contacts.load(true));
    $ctrl.bus = new ServiceBus();
    var url = 'QueryVendorContacts.json?vendorId=' + (this.id || this.vendorId || this.vendorId || this.vendor.id);
    if (this.contactId) { url = url + "&Id=" + this.contactId }
    $ctrl.contacts = new AutoQuery({
      url: url,
      orderBy: 'Name',
      autoLoad: true,
      pageSize: 10
    })
  }
  deleteContact(contact) {
    const $ctrl = this;

    return modals.confirm("Are you sure?", "Delete Contact").result.then(function () {
      $ctrl.bus.send('DeleteVendorContact.json', contact).then(function (response) {
        $ctrl.$emit('contactDeleted', $ctrl);
        $ctrl.contacts.load(true);
      });
    });
  }
  contactPopup(contact) {
    const $ctrl = this;
    VendorContactPopup.open({ vendor: $ctrl.vendor, contactId: contact.id });
  }
}

let VendorContacts = {
  bindings: {
    id: '@',
    vendorId: '@',
    vendor: '<',
    contactId: '@'
  },
  controller: VendorContactsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || ($attrs.table ? tableTemplateUrl : cardTemplateUrl)
  }
}

export default VendorContacts